// JS
import '../../custom/js/custom/index';
import '../../custom/js/custom/pagebuilder';

// Custom JS
import '../../custom/js/custom/components/request-quote';

// Base SCSS
import '../../custom/scss/common/base.scss';
import '../../custom/scss/custom/layout.scss';
import '../../custom/scss/custom/layout/header/_header-simple.scss';

// Components SCSS
import '../../custom/scss/custom/page-builder.scss';
import '../../custom/scss/custom/components/modal/modal-privacy-information.scss';
import '../../custom/scss/custom/components/hero/hero-circle.scss';
import '../../custom/scss/custom/components/form/form-agent-search-results.scss';
import '../../custom/scss/custom/components/agent-tray/agent-tray.scss';
import '../../custom/scss/custom/components/request-quote-form/request-quote-form.scss';
import '../../custom/scss/custom/components/adhoc-forms/adhoc-forms-thank-you.scss';

// Import Vue App
import Vue from 'vue';
import VueApp from '../../custom/vue/request-quote-search';
import App from '../../custom/vue/custom-apps/containers/request-quote-search.vue';

// connect vue component and init app
Vue.component('app', App);

if (document.getElementById('request-quote-app') !== null) {
    VueApp.$mount('#request-quote-app');
}
